<template>
  <div class="containerSelectNarrow">
    <p-drop-down-container v-model="pussOption">
      <template v-slot:content>
        <div :class="classInput">
          <div>{{ selectedText }}</div>
          <div class="expand_moreSelectNarrow">
            <PIcon icon="expand_less" type="material" color="#ffd102" v-if="pussOption"></PIcon>
            <PIcon icon="expand_more" type="material" color="#ffd102" v-else></PIcon>
          </div>
        </div>
      </template>

      <div class="optionsSelectNarrow">
        <div
          v-for="(option, index) in options"
          :key="index"
          @click="selectItem(option.value)"
          :class="giveMeClass(option.value)"
        >
          {{ option.text }}
        </div>
      </div>
    </p-drop-down-container>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SelectType } from "./pFormSelect.types";
import PDropDownContainer from "../PDropDownContainer/PDropDownContainer.vue";
import PIcon from "../PIcon/PIcon.vue";

@Component({
  components: {
    PDropDownContainer,
    PIcon,
  },
})
export class PFormSelectNarrow extends Vue {
  @Prop({ required: true }) value!: any;
  @Prop({ required: true }) options!: SelectType[];
  @Prop({ required: false, default: "Select an option" }) placeholder!: string;

  @Watch("value", { immediate: true })
  onChangeValue(): void {
    if (this.value) {
      this.selectedItemValue = Object.assign(this.value);
    }
  }
  pussOption = false;
  selectedItemValue = "";
  pulsadoApertura = false;

  get classInput(): string {
    if (this.pussOption) {
      return "inputSelectNarrowOpen dedo";
    } else {
      return "inputSelectNarrow dedo";
    }
  }

  get selectedText(): string {
    const optionFind = this.options.find((opt) => opt.value == this.selectedItemValue);
    if (optionFind) {
      return optionFind.text;
    } else {
      return this.placeholder;
    }
  }
  selectItem(itemValue: unknown): void {
    this.pussOption = false;
    this.$emit("input", itemValue);
    this.$emit("change", itemValue);
  }
  giveMeClass(itemValue: unknown): string {
    if (this.selectedItemValue === itemValue) {
      return "dedo itemSelectNarrowSelected";
    } else {
      return "dedo itemSelectNarrow";
    }
  }
}
export default PFormSelectNarrow;
</script>
<style scoped>
.containerSelectNarrow {
  position: relative;
}
.inputSelectNarrow,
.inputSelectNarrowOpen {
  display: flex;
  white-space: nowrap;
  align-items: center;
}
.inputSelectNarrowOpen {
  border-radius: 4px;
}
.optionsSelectNarrow {
  display: flex;
  flex-direction: column;
}
.itemSelectNarrow,
.itemSelectNarrowSelected {
  padding-left: 3px;
  border-bottom: solid 1px rgb(151, 151, 151, 0.13);
  object-fit: contain;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 3;
  letter-spacing: normal;
  white-space: nowrap;
}
.itemSelectNarrowSelected {
  color: #d7b000;
}
.itemSelectNarrow:hover {
  background-color: rgb(151, 151, 151, 0.13);
}

.expand_moreSelectNarrow {
  color: #d7b000;
  margin-top: 4px;
  margin-left: 5px;
}
.expand_moreSelectNarrow span {
  font-size: 18px;
}
</style>
